<div class="w-full">
    @if (showLabel) {
    <label class="block text-xs font-normal text-gray-600 dark:text-slate-400 mb-1.5">
        {{ label }}
        @if (showAsteric) {
        <span class="text-error">*</span>
        }
    </label>
    }

    <div class="relative w-full">
        @if (isTextarea) {
        <textarea [placeholder]="placeholder" [value]="value" [disabled]="isDisabled" [readonly]="readonly"
            [attr.maxLength]="maxlength" [rows]="rows" (input)="onInput($event)"
            [ngStyle]="{ 'background-color': inputBackgroundColor }" class="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 
        focus:outline-none focus:ring-1 focus:ring-gray-400 dark:focus:ring-slate-500 focus:border-gray-400 dark:focus:border-slate-500
        disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed disabled:text-gray-500 dark:text-slate-400
        resize-vertical transition-colors"></textarea>
        } @else {
        <input [type]="type" [placeholder]="placeholder" [value]="value" [disabled]="isDisabled" [readonly]="readonly"
            [attr.maxLength]="maxlength" [attr.max]="max || null" (input)="onInput($event)"
            [ngStyle]="{ 'background-color': inputBackgroundColor }" class="w-full h-12 px-4 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 
        focus:outline-none focus:ring-1 focus:ring-gray-400 dark:focus:ring-slate-500 focus:border-gray-400 dark:focus:border-slate-500
        disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed disabled:text-gray-500 dark:text-slate-400
        transition-colors" [class.pr-10]="!showSuffixIcon" />
        }

        @if (showPrefixIcon && prefixIcon) {
        <img [src]="prefixIcon" alt=""
            class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none opacity-50">
        }

        @if (showSuffixIcon && suffixIcon) {
        <img [src]="suffixIcon" alt=""
            class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none opacity-40">
        }
    </div>
</div>